import FilterBase from './FilterBase.vue';
import FiltersBox from './FiltersBox.vue';

import TextFilter from './TextFilter.vue';
import OptionFilter from './OptionFilter.vue';
import Pager from './Pager.vue';
import ConditionalDateRangeFilter from './ConditionalDateRangeFilter.vue';
import DateRangeFilter from './DateRangeFilter.vue';
import NumericRangeFilter from './NumericRangeFilter.vue';
import AutoCompleteMultiSelectFilter from './AutoCompleteMultiSelectFilter.vue';
import MultiSelectFilter from './MultiSelectFilter.vue';
import AutoCompleteFilter from './AutoCompleteFilter.vue';

export default {
    FilterBase,
    FiltersBox,
    TextFilter,
    OptionFilter,
    Pager,
    ConditionalDateRangeFilter,
    DateRangeFilter,
    NumericRangeFilter,
    MultiSelectFilter,
    AutoCompleteFilter,
    AutoCompleteMultiSelectFilter,
};
